"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextPropagationMenu = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TextPropagationMenu = function (_a) {
    var propagateStyleDisabled = _a.propagateStyleDisabled, onPropagateStyle = _a.onPropagateStyle, onResetStyle = _a.onResetStyle;
    return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.StylesBrushUpdate, null), tooltip: { content: "Style modified" } }), theme: "dark", offset: 8, autoStack: true },
        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.Tick, null), disabled: propagateStyleDisabled, onClick: onPropagateStyle }, "Update block"),
        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { icon: react_1.default.createElement(icons_1.Retry, null), onClick: onResetStyle }, "Reset style")));
};
exports.TextPropagationMenu = TextPropagationMenu;
